function userType() {
    const token = localStorage.getItem('sgc_br');
    const tokenJSON = JSON.parse(token)
    return tokenJSON.type;
}

export default userType;